export default "__VITE_ASSET__BkS9e00f__"